import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <span className="footer-logo">
          SS<span style={{ color: "var(--accent)" }}>.</span>
        </span>
        <p className="footer-text">
          Designed & built by{" "}
          <span style={{ color: "var(--accent)" }}>Sumima Shakya</span> ·{" "}
          {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
